var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStreetview = function SvgStreetview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M7.635 20.848H4.17A2.17 2.17 0 0 1 2 18.678V9.926a2.17 2.17 0 0 1 2.17-2.17h26.77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M30.94 7.755h3.161c.47 0 .925.152 1.3.433l5.847 4.377a2.17 2.17 0 0 1 0 3.473l-5.846 4.377a2.17 2.17 0 0 1-1.3.433H7.635M23.572 20.862v22.115c0 .846-.486 1.531-1.085 1.531h-2.813c-.6 0-1.085-.685-1.085-1.53V20.861M18.589 26.077v-5.229M23.572 20.848v5.229M18.589 7.755v-4.67c0-.6.486-1.085 1.085-1.085h2.813c.6 0 1.085.486 1.085 1.085v4.67"
  })));
};
export default SvgStreetview;